module.exports = __webpack_public_path__ + "static/media/connectedstores.6bfb6593.svg";